{
  "round": {
    "x": 56,
    "y": 52,
    "w": 180,
    "h": 42,
    "lane": {
      "x": 40,
      "y": 42,
      "w": 196,
      "h": 54
    }
  },
  "target.label": {
    "x": 488,
    "y": 270,
    "w": 126,
    "h": 27,
    "lane": {
      "x": 486,
      "y": 268,
      "w": 128,
      "h": 30
    }
  },
  "seat1.name": {
    "x": 72,
    "y": 422,
    "w": 44,
    "h": 22,
    "lane": {
      "x": 40,
      "y": 420,
      "w": 116,
      "h": 42
    }
  },
  "seat2.name": {
    "x": 219,
    "y": 427,
    "w": 39,
    "h": 26,
    "lane": {
      "x": 184,
      "y": 420,
      "w": 116,
      "h": 42
    }
  },
  "seat3.name": {
    "x": 358,
    "y": 427,
    "w": 44,
    "h": 28,
    "lane": {
      "x": 328,
      "y": 420,
      "w": 116,
      "h": 42
    }
  },
  "seat4.name": {
    "x": 522,
    "y": 422,
    "w": 51,
    "h": 29,
    "lane": {
      "x": 484,
      "y": 422,
      "w": 128,
      "h": 40
    }
  },
  "seat5.name": {
    "x": 687,
    "y": 428,
    "w": 38,
    "h": 17,
    "lane": {
      "x": 644,
      "y": 420,
      "w": 116,
      "h": 42
    }
  },
  "seat6.name": {
    "x": 839,
    "y": 427,
    "w": 23,
    "h": 19,
    "lane": {
      "x": 790,
      "y": 420,
      "w": 116,
      "h": 42
    }
  },
  "question": {
    "x": 110,
    "y": 495,
    "w": 720,
    "h": 131,
    "lane": {
      "x": 80,
      "y": 494,
      "w": 780,
      "h": 142
    }
  },
  "instruction": {
    "x": 90,
    "y": 625,
    "w": 760,
    "h": 62,
    "lane": {
      "x": 80,
      "y": 632,
      "w": 782,
      "h": 62
    }
  },
  "num1": {
    "x": 163,
    "y": 732,
    "w": 43,
    "h": 41,
    "lane": {
      "x": 150,
      "y": 711,
      "w": 72,
      "h": 68
    }
  },
  "text1": {
    "x": 268,
    "y": 733,
    "w": 96,
    "h": 29,
    "lane": {
      "x": 250,
      "y": 713,
      "w": 380,
      "h": 64
    }
  },
  "way1": {
    "x": 638,
    "y": 709,
    "w": 128,
    "h": 75,
    "lane": {
      "x": 636,
      "y": 703,
      "w": 170,
      "h": 84
    }
  },
  "num2": {
    "x": 163,
    "y": 811,
    "w": 43,
    "h": 46,
    "lane": {
      "x": 150,
      "y": 796,
      "w": 72,
      "h": 68
    }
  },
  "text2": {
    "x": 269,
    "y": 818,
    "w": 79,
    "h": 34,
    "lane": {
      "x": 250,
      "y": 798,
      "w": 380,
      "h": 64
    }
  },
  "way2": {
    "x": 638,
    "y": 795,
    "w": 109,
    "h": 74,
    "lane": {
      "x": 636,
      "y": 788,
      "w": 170,
      "h": 84
    }
  },
  "num3": {
    "x": 164,
    "y": 898,
    "w": 37,
    "h": 46,
    "lane": {
      "x": 150,
      "y": 884,
      "w": 72,
      "h": 68
    }
  },
  "text3": {
    "x": 268,
    "y": 905,
    "w": 105,
    "h": 31,
    "lane": {
      "x": 250,
      "y": 886,
      "w": 380,
      "h": 64
    }
  },
  "way3": {
    "x": 636,
    "y": 881,
    "w": 170,
    "h": 79,
    "lane": {
      "x": 636,
      "y": 876,
      "w": 170,
      "h": 84
    }
  },
  "num4": {
    "x": 163,
    "y": 982,
    "w": 46,
    "h": 47,
    "lane": {
      "x": 150,
      "y": 969,
      "w": 72,
      "h": 68
    }
  },
  "text4": {
    "x": 268,
    "y": 981,
    "w": 362,
    "h": 54,
    "lane": {
      "x": 250,
      "y": 971,
      "w": 380,
      "h": 64
    }
  },
  "way4": {
    "x": 636,
    "y": 961,
    "w": 170,
    "h": 84,
    "lane": {
      "x": 636,
      "y": 961,
      "w": 170,
      "h": 84
    }
  },
  "num5": {
    "x": 165,
    "y": 1072,
    "w": 43,
    "h": 45,
    "lane": {
      "x": 150,
      "y": 1056,
      "w": 72,
      "h": 68
    }
  },
  "text5": {
    "x": 267,
    "y": 1058,
    "w": 360,
    "h": 53,
    "lane": {
      "x": 250,
      "y": 1058,
      "w": 380,
      "h": 64
    }
  },
  "way5": {
    "x": 636,
    "y": 1048,
    "w": 170,
    "h": 33,
    "lane": {
      "x": 636,
      "y": 1048,
      "w": 170,
      "h": 84
    }
  },
  "num6": {
    "x": 163,
    "y": 1156,
    "w": 45,
    "h": 47,
    "lane": {
      "x": 150,
      "y": 1142,
      "w": 72,
      "h": 68
    }
  },
  "text6": {
    "x": 266,
    "y": 1162,
    "w": 114,
    "h": 31,
    "lane": {
      "x": 250,
      "y": 1144,
      "w": 380,
      "h": 64
    }
  },
  "default": {
    "x": 171,
    "y": 1256,
    "w": 127,
    "h": 38,
    "lane": {
      "x": 166,
      "y": 1256,
      "w": 136,
      "h": 40
    }
  },
  "allsix": {
    "x": 449,
    "y": 1290,
    "w": 199,
    "h": 29,
    "lane": {
      "x": 360,
      "y": 1290,
      "w": 340,
      "h": 38
    }
  },
  "cta.label": {
    "x": 247,
    "y": 1395,
    "w": 471,
    "h": 67,
    "lane": {
      "x": 180,
      "y": 1382,
      "w": 580,
      "h": 80
    }
  },
  "callit.label": {
    "x": 299,
    "y": 1514,
    "w": 112,
    "h": 36,
    "lane": {
      "x": 286,
      "y": 1506,
      "w": 138,
      "h": 48
    }
  },
  "callit.hint": {
    "x": 450,
    "y": 1523,
    "w": 248,
    "h": 24,
    "lane": {
      "x": 436,
      "y": 1512,
      "w": 288,
      "h": 40
    }
  },
  "hint": {
    "x": 295,
    "y": 1505,
    "w": 289,
    "h": 31,
    "lane": {
      "x": 262,
      "y": 1504,
      "w": 340,
      "h": 32
    }
  }
}